import React from 'react';
import { Button } from 'components';
import { isIOS, isMobile } from 'react-device-detect';
import classNames from 'classnames';
import './BottomButton.scss';

const BottomButton = (props) => {
  const classes = classNames({
    'nw-bottom-button': true,
    'nw-button-button--ios': isMobile && isIOS,
  });
  return (
    <div className={classes}>
      <Button {...props} />
    </div>
  );
};

export default BottomButton;
